import { createAction, props } from '@ngrx/store'

export const resetState = createAction('[Profile Admin] Reset State')

export const addPerson = createAction(
  '[Profile Admin] Add Person',
  props<{
    orgId: number
    personaIds?: string[]
    affiliatePermissionOrganization?: string
    triggerId?: string
    defaultNoGrant?: boolean
    title?: string
  }>()
)

export const removeAccess = createAction(
  '[Profile Admin] Remove Access',
  props<{ orgId: number; personaIds: string[]; triggerId?: string }>()
)

export const editRolesPermissions = createAction(
  '[Profile Admin] Edit Roles Permissions',
  props<{ orgId: number; personaIds: string[]; affiliatePermissionOrganization?: string; triggerId?: string }>()
)

export const sendMessage = createAction(
  '[Profile Admin] Send Message',
  props<{ orgId: number; personaIds: string[]; personaNames?: string[]; triggerId?: string }>()
)

export const addToGroup = createAction(
  '[Profile Admin] Add To Group',
  props<{ orgId: number; personaIds: string[]; groupId?: string; triggerId?: string }>()
)

export const buyMembership = createAction(
  '[Profile Admin] Buy Membership',
  props<{
    orgId: number
    personaIds: string[]
    membershipType?: string
    membershipDefinitionId?: string
    availableMembershipDefinitionIds?: string[]
    triggerId?: string
  }>()
)
